export default "__VITE_ASSET__CH$jtySz__"